import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DefaultLayout } from "../../../../layouts/Default";
import { Main } from "../../../../themes/Default/components/Main";
import { TopNavigation } from "../../../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../themes/Default/components/Breadcrumps/components/Link";
import { Button, ButtonBack } from "../../../../themes/Default/components/TopNavigation/components/Button";
import { List } from "../../../../themes/Default/components/List";
import { Header as ListHeader } from "../../../../themes/Default/components/List/components/Header";
import { Body as ListBody } from "../../../../themes/Default/components/List/components/Body";
import { TableHead } from "../../../../themes/Default/components/List/components/Body/components/TableHead";
import { TableBody } from "../../../../themes/Default/components/List/components/Body/components/TableBody";
import { TableRow } from "../../../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow";
import { TableHeadCell } from "../../../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow/components/TableHeadCell";
import { TableDataCell } from "../../../../themes/Default/components/List/components/Body/components/TableBody/components/TableDataCell";
import { studentsManagement } from "../../../../hooks/api/StudentsManagement";
import { Tabs } from "../../../../themes/Default/components/Tabs";
import { useTranslation } from "react-i18next";
import { Title } from "../../../../themes/Default/components/Title";
import { callsManagement } from "../../../../hooks/api/CallsManagement";

const Calls = () => {
    const { t } = useTranslation("common");
    const navigate = useNavigate();
    const [student, setStudent] = useState();
    const { studentId } = useParams();
    const {  useViewStudentsMutation} = studentsManagement;
    const [viewStudents] = useViewStudentsMutation();

    const { useCallsListByStudentMutation } = callsManagement;
    const [viewCalls] = useCallsListByStudentMutation();
    const [calls, setCalls] = useState([]);

    const gotoDetailsTab = (studentId) => {
        navigate("/students/edit/" + studentId);
    };

    const gotoNotesTab = (studentId) => {
        navigate('/students/' + studentId + '/notes');
    }

    const gotoTestsTab = (studentId) => {
        navigate('/students/' + studentId + '/tests');
    }

    const gotoDocumentsTab = (studentId) => {
        navigate('/students/' + studentId + '/documents');
    }

    const gotoCertificatesTab = (studentId) => {
        navigate('/students/' + studentId + '/certificates');
    }

    const gotoContractsTab = (studentId) => {
        navigate("/students/" + studentId + "/contracts");
    };

    const gotoGroupsTab = (studentId) => {
        navigate("/students/" + studentId + "/groups");
    };

    const tabs = [
        { title: t('details'), onClick: () => gotoDetailsTab(studentId) },
        // { title: t('students.tests'), onClick: () => gotoTestsTab(studentId)},
        { title: t("students.contract"), onClick: () => gotoContractsTab(studentId) },
        { title: t("calls.title"), isActive: true },
        { title: t('groups.title'), onClick: () => gotoGroupsTab(studentId)},
        { title: t('students.certificates'), onClick: () => gotoCertificatesTab(studentId)},
        { title: t('documents'), onClick: () => gotoDocumentsTab(studentId)},
        { title: t('notes'), onClick: () => gotoNotesTab(studentId)},
    ];

    const gotoEdit = (callId) => {
        navigate("/calls/edit/" + callId);
    };

    useEffect(() => {
        viewStudents(studentId).then((result) => {
            setStudent(result?.data);
        });
        viewCalls(studentId).then((result) => {
            console.log(result)
            setCalls(result?.data?.records);
        });
    }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/students" />
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
            <Title>
                    {student?.firstName} {student?.lastName}
                </Title>
                <Breadcrumps>
                    <Link title={t('students.title')} icon="fa-user-graduate" />
                    <Link title={t('details')} />
                    <Link title={t('calls.title')} isActive={true} />
                </Breadcrumps>
                <List>
                    <ListHeader>
                    </ListHeader>
                    <ListBody>
                        <TableHead>
                            <TableRow>
                                <TableHeadCell></TableHeadCell>
                                <TableHeadCell>
                                    <span>{t("test.date")}</span>
                                </TableHeadCell>
                                <TableHeadCell>
                                    <span>{t("students.guardian")}</span>
                                </TableHeadCell>
                                <TableHeadCell>
                                    <span>{t("students.phoneNumber")}</span>
                                </TableHeadCell>
                                <TableHeadCell>
                                    <span>{t("Status poziva")}</span>
                                </TableHeadCell>
                                <TableHeadCell>
                                    <span>{t("calls.old/new")}</span>
                                </TableHeadCell>
                                <TableHeadCell>
                                    <span>{t("students.contractGroupType")}</span>
                                </TableHeadCell>
                                <TableHeadCell>
                                    <span>{t("groups.classStartTime")}</span>
                                </TableHeadCell>
                                <TableHeadCell>
                                    <span>{t("test.locationName")}</span>
                                </TableHeadCell>
                                <TableHeadCell>
                                    <span>{t("calls.createdBy")}</span>
                                </TableHeadCell>
                                <TableHeadCell></TableHeadCell>  
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {calls?.length > 0 &&
                            calls?.map((call, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableDataCell>
                                            <Button icon="fa-regular fa-pen" onClick={() => gotoEdit(call.id)}></Button>
                                        </TableDataCell> 
                                        <TableDataCell>{call.date}</TableDataCell>
                                        <TableDataCell>
                                            {(call.guardian1FirstName || call.guardian1LastName) 
                                            ? `${call.guardian1FirstName ?? ''} ${call.guardian1LastName ?? ''}`.trim()
                                            : ''}
                                        </TableDataCell>
                                        <TableDataCell>{call.guardian1PhoneNumber}</TableDataCell>
                                        <TableDataCell>{call.statusName}</TableDataCell>
                                        <TableDataCell>{call.studentStatusName}</TableDataCell>
                                        <TableDataCell>{call.courseTypeName}</TableDataCell>
                                        <TableDataCell>{call.appointmentName}</TableDataCell>
                                        <TableDataCell>{call.locationName}</TableDataCell>
                                        <TableDataCell>{call.createdByUsername}</TableDataCell>
                                        <TableDataCell></TableDataCell> 
                                    </TableRow>
                                )
                        })}
                        </TableBody>
                    </ListBody>
                </List>
            </Main>
        </DefaultLayout>
    );
};

export default Calls;
